module.exports = __webpack_public_path__ + "static/media/transportation-hospitality-square.f1485c7e.jpg";